import { useCallback, useState } from 'react';
export const useMutableValue = initialState => {
  const [mutableValue, setMutableValue] = useState(initialState);
  const resetValue = useCallback(() => setMutableValue(initialState), [initialState]);
  return [mutableValue, setMutableValue, initialState, resetValue];
};